import React from 'react';

interface GridComponentProps {
  url: string;
  index: number;
}

type Props = React.FC<React.HTMLProps<HTMLDivElement> & GridComponentProps>;

const GridComponent: Props = ({ url, alt, index, title, className, children, ...props }) => {
  return (
    <div {...props} className={`space-y-16 ${className ? className : ''}`}>
      <img
        src={`${url}?fm=png&w=379&h=274&fit=crop&crop=focalpoint&fp-y=.4&auto=format`}
        alt={alt}
        width="379"
        height="274"
        loading="lazy"
      />
      <div>
        <span className="text-h4 absolute -ml-32 leading-6 text-gray">{`${index}`.padStart(2, '0')}</span>
        <span className="text-h3 leading-6">{title}</span>
      </div>

      {children}
    </div>
  );
};

export default GridComponent;
